<template>
	<div class="date-chooser">
		<DatePicker expanded borderless ref="date-picker" v-model="currentDate" mode="date" :min-date='new Date()' :max-date="maxDate" color="business" @update:modelValue="changedCalendarDate" :disabled-dates="disabledDates" />
	</div>
</template>

<script>
import MenuTabs from "@/new-menu/components/generic/MenuTabs.vue";
import {useReservationsStore} from "@/book/stores";
import {useMenusStore} from "@/new-menu/stores";
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const reservationsStore = useReservationsStore();
		const menusStore = useMenusStore();
		const languageStore = useLanguageStore();
		return {reservationsStore, menusStore, getString: languageStore.getString};
	},
	name: "DateChooser" ,
	components: {MenuTabs},
	data() {
		return {
			currentDate: null,
		}
	},
	computed: {
		maxDate() {
			let maxDate = new Date();
			maxDate.setDate(maxDate.getDate() + (this.reservationsStore.selectedExperience.days_advance ? this.reservationsStore.selectedExperience.days_advance : 30));
			return maxDate;
		},
		disabledDates() {
			let result = [];
			if(this.reservationsStore.selectedExperience.exceptions) {
				for(let i = 0; i < this.reservationsStore.selectedExperience.exceptions.length; i++) {
					let exception = this.reservationsStore.selectedExperience.exceptions[i];
					if(exception.timeslots.length === 0) {
						result.push(new Date(exception.date));
					}
				}
			}

			let emptyWeekdays = [0, 1, 2, 3, 4, 5, 6];
			this.reservationsStore.selectedExperience.timeslots.forEach(t => {
				if(t.weekday !== null) {
					emptyWeekdays = emptyWeekdays.filter(d => d !== (t.weekday+1)%7);
				}
			});
			if(emptyWeekdays.length > 0) {
				emptyWeekdays = emptyWeekdays.map(d => d+1);
				result.push({
					repeat: {
						weekdays: emptyWeekdays
					}
				});
			}
			return result;
		}
	},
	methods: {
		changedCalendarDate() {
			this.reservationsStore.chosenDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate());
			this.reservationsStore.updateExperienceAvailability();
		}
	}
}
</script>

<style lang="scss">
.vc-business {
	border-radius: var(--vc-rounded);

	--vc-accent-50: var(--business-color-alpha20);
	--vc-accent-100: var(--business-color-alpha20);
	--vc-accent-200: var(--business-color-alpha40);
	--vc-accent-300: var(--business-color-alpha40);
	--vc-accent-400: var(--business-color-alpha60);
	--vc-accent-500: var(--business-color-alpha60);
	--vc-accent-600: var(--business-color-alpha80);
	--vc-accent-700: var(--business-color-alpha80);
	--vc-accent-800: var(--business-color);
	--vc-accent-900: var(--business-color);

	--vc-font-family: var(--font-family);
	--vc-rounded: var(--rounded-corner-s);
	--vc-rounded-md: var(--rounded-corner);
	--vc-rounded-lg: var(--rounded-corner);
	--vc-rounded-full: var(--rounded-corner-l);

	--vc-shadow: var(--theme-box-shadow);
	--vc-shadow-lg: var(--theme-box-shadow-strong);
	--vc-shadow-inner: inset var(--theme-box-shadow-light);

	--vc-text-sm: var(--font-size-xs);
	--vc-text-base: var(--font-size-s);
	--vc-text-lg: var(--font-size-m);

	&.vc-light {
		--vc-bg: var(--theme-bg2-color);
		--vc-color: var(--theme-txt2-color);
		--vc-border-color: var(--business-color);
		--vc-hover-bg: var(--theme-bg2-color);
		--vc-focus-ring: 0 0 0 2px var(--business-color-alpha60);

		--vc-header-arrow-color: var(--theme-txt2-color);
		--vc-header-arrow-hover-bg: var(--business-color-alpha20);
		--vc-header-title-color: var(--theme-txt1-color);
		--vc-weekday-color: var(--theme-txt2-color);
		--vc-weeknumber-color: var(--theme-txt2-color);

		--vc-nav-hover-bg: var(--business-color-alpha20);
		--vc-nav-title-color: var(--theme-txt1-color);
		--vc-nav-item-active-color: var(--business-text-color);
		--vc-nav-item-active-bg: var(--business-color-alpha80);
		--vc-nav-item-active-box-shadow: var(--theme-box-shadow);
		--vc-nav-item-current-color: var(--business-text-color);

		--vc-day-popover-container-color: var(--theme-bg1-color);
		--vc-day-popover-container-bg: var(--theme-bg2-color);
		--vc-day-popover-container-border: var(--theme-bg2-color);
		--vc-day-popover-header-color: var(--theme-txt1-color);

		--vc-popover-content-color: var(--theme-bg1-color);
		--vc-popover-content-bg: var(--theme-bg1-color);
		--vc-popover-content-border: var(--theme-bg2-color);

		--vc-select-color: var(--theme-txt1-color);
		--vc-select-bg: var(--theme-bg1-color);
		--vc-select-hover-bg: var(--theme-bg2-color);

		--vc-day-content-hover-bg: var(--theme-bg2-color);
		--vc-day-content-disabled-color: var(--theme-txt1-alpha20-color);

		&.vc-attr,
		& .vc-attr {
			--vc-highlight-outline-bg: var(--theme-bg2-color);
			--vc-highlight-solid-content-color: var(--business-text-color);
		}

		.vc-day-content:hover {
			color: var(--theme-txt1-color);
		}

		.vc-header {
			.vc-title {
				span {
					color: var(--theme-txt1-color);
				}
			}
		}

		.vc-nav-items {
			.vc-nav-item {
				color: var(--theme-txt2-color);

				&.is-active {
					color: var(--business-text-color);
				}
			}
		}
	}
}
</style>
<style scoped lang="scss">
.date-chooser {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	max-width: 420px;
}
</style>